  (function(){
      emailjs.init("JLN545bRtFF4f-3_U");
   })();

  (function () {
    const EMAILJS_SERVICE_ID = "service_r3lt825"; 
    const EMAILJS_TEMPLATE_ID = "template_kuucj8o";

    const continentEl = document.getElementById('w-continent');
    const countryEl = document.getElementById('w-country');
    const nameEl = document.getElementById('w-name');
    const emailEl = document.getElementById('w-email');
    const privacyEl = document.getElementById('w-privacy');
    const submitBtn = document.getElementById('w-submit');
    const form = document.getElementById('wholesale-form');
    const productsEl = document.getElementById('w-products');
    const inquiryEl = document.getElementById('w-inquiry');
    
    const modalOverlay = document.getElementById('status-modal');
    const modalIcon = document.getElementById('modal-icon');
    const modalTitle = document.getElementById('modal-title');
    const modalMessage = document.getElementById('modal-message');
    const modalCloseBtn = document.getElementById('modal-close-btn');

    const europeCountries = [
      'Albania','Andorra','Armenia','Austria','Azerbaijan','Belarus','Belgium','Bosnia and Herzegovina',
      'Bulgaria','Croatia','Cyprus','Czech Republic','Denmark','Estonia','Finland','France','Georgia',
      'Germany','Greece','Hungary','Iceland','Ireland','Italy','Kazakhstan','Kosovo','Latvia','Liechtenstein',
      'Lithuania','Luxembourg','Malta','Moldova','Monaco','Montenegro','Netherlands','North Macedonia',
      'Norway','Poland','Portugal','Romania','Russia','San Marino','Serbia','Slovakia','Slovenia','Spain',
      'Sweden','Switzerland','Turkey','Ukraine','United Kingdom','Vatican City'
    ];
    const usCaCountries = ['United States', 'Canada'];

    function populateCountries(list) {
      countryEl.innerHTML = '<option value="">Please choose a country</option>';
      list.forEach((c) => {
        const opt = document.createElement('option');
        opt.value = c;
        opt.textContent = c;
        countryEl.appendChild(opt);
      });
      countryEl.disabled = false;
    }


    continentEl.addEventListener('change', function () {
      const val = continentEl.value;
      if (!val) {
        countryEl.innerHTML = '<option value="">Please choose a country</option>';
        countryEl.disabled = true;
      } else if (val === 'Europe') {
        populateCountries(europeCountries);
      } else if (val === 'North America') {
        populateCountries(usCaCountries);
      } else {
        countryEl.disabled = true;
      }
      checkEnableSubmit();
    });

    [nameEl, emailEl, continentEl, countryEl, privacyEl].forEach((el) => {
      el.addEventListener('input', checkEnableSubmit);
      el.addEventListener('change', checkEnableSubmit);
    });

    function isEmailValid(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function checkEnableSubmit() {
      const nameOk = nameEl.value.trim().length > 0;
      const emailOk = isEmailValid(emailEl.value.trim());
      const continentOk = continentEl.value.trim().length > 0;
      const countryOk = countryEl.value.trim().length > 0 && !countryEl.disabled;
      const privacyOk = privacyEl.checked === true;

      const enabled = nameOk && emailOk && continentOk && countryOk && privacyOk;
      submitBtn.disabled = !enabled;
    }

    function autosizeTextarea(el) {
      if (!el) return;
      el.style.height = 'auto';
      el.style.height = el.scrollHeight + 1 + 'px';
    }

    [productsEl, inquiryEl].forEach((t) => {
      autosizeTextarea(t);
      t.addEventListener('input', () => autosizeTextarea(t));
    });


    function showModal(type, title, message) {
        modalOverlay.classList.add('show');
        modalTitle.textContent = title;
        modalMessage.textContent = message;
        
        modalIcon.classList.remove('success', 'error');
        modalIcon.innerHTML = '';

        if(type === 'success') {
            modalIcon.classList.add('success');
            modalIcon.innerHTML = '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-1.25 17.292l-4.5-4.5 1.757-1.758 2.743 2.742 7-7 1.757 1.758-8.757 8.758z"/></svg>';
        } else {
            modalIcon.classList.add('error');
            modalIcon.innerHTML = '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm3.536 14.121l-1.415 1.415L12 13.414l-2.121 2.122-1.415-1.415L10.586 12 8.464 9.879l1.415-1.415L12 10.586l2.121-2.122 1.415 1.415L13.414 12l2.122 2.121z"/></svg>';
        }
    }

    function closeModal() {
        modalOverlay.classList.remove('show');
    }

    modalCloseBtn.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', function(e){
        if(e.target === modalOverlay) closeModal();
    });


    form.addEventListener('submit', function (evt) {
      evt.preventDefault(); 

      const nameOk = nameEl.value.trim().length > 0;
      const emailOk = isEmailValid(emailEl.value.trim());
      const continentOk = continentEl.value.trim().length > 0;
      const countryOk = countryEl.value.trim().length > 0 && !countryEl.disabled;
      const privacyOk = privacyEl.checked === true;

      if (!(nameOk && emailOk && continentOk && countryOk && privacyOk)) {
        showModal('error', 'Incomplete Form', 'Please fill in all required fields and agree to the privacy policy.');
        return;
      }

      submitBtn.disabled = true;
      const originalBtnText = submitBtn.textContent;
      submitBtn.textContent = 'Sending...';

      emailjs.sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, this)
        .then(function() {
            submitBtn.textContent = originalBtnText;
            submitBtn.disabled = false;
            form.reset();
            countryEl.innerHTML = '<option value="">Please choose a country</option>';
            countryEl.disabled = true;
            checkEnableSubmit();
            
            showModal('success', 'Thank You!', 'Your partnership inquiry has been sent successfully. Our team will contact you soon.');
        }, function(error) {
            console.error('FAILED...', error);
            submitBtn.textContent = originalBtnText;
            submitBtn.disabled = false;
            
            showModal('error', 'Submission Failed', 'Something went wrong while sending your request. Please try again later or contact us directly.');
        });
    });

    checkEnableSubmit();
  })();